export default "__VITE_ASSET__71448e16__"